import { render, staticRenderFns } from "./VariationsList.vue?vue&type=template&id=f68002f2"
import script from "./VariationsList.vue?vue&type=script&lang=js"
export * from "./VariationsList.vue?vue&type=script&lang=js"
import style0 from "./VariationsList.vue?vue&type=style&index=0&id=f68002f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports